export default __webpack_public_path__ + "static/media/logo.617dd628.png";